import React, { Component } from 'react';
var DatePicker = require('react-datepicker');
import moment from 'moment';
import { LabelWithArrow } from './basic';

var CustomLabel = React.createClass({
    propTypes: {
        onClick: React.PropTypes.func,
        value: React.PropTypes.string
    },

    render() {
        return (<LabelWithArrow
            onClick={this.props.onClick}
            className='chooseDate h5'
            Label={this.props.Label} />)
    }
});

var CustomContainerType = React.createClass({
    render() {
        var dateFormatted = this
            .props
            .value
            .format("DD.MM.YYYY");
        if (this.props.ContainerType == 'label') {
            return (
                <label onClick={this.props.onClick}>{dateFormatted}</label>
            )
        } else if (this.props.ContainerType == 'None') {
            return null;
        } else {
            return (<input
                type='text'
                value={dateFormatted}
                className="shortDate"
                onClick={this.props.onClick}
                readOnly />)
        }
    }
});

var Datepicker = class Datepicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: moment(new Date(this.props.startDate)),
            endDate: moment(new Date(this.props.endDate))
        };
    };

    handleChange(date) {
        //if (this.props.type == "start")
        this.setState({ startDate: moment(date) });
        console.log(moment(date));
        // else
        this.setState({ endDate: moment(date) });
        if (this.props.onChange) {
            this
                .props
                .onChange(date.toDate());
        }
    };

    componentWillReceiveProps(nextProps) {
        var nextDateStart = moment(new Date(nextProps.startDate));
        var curDateStart = this.state.startDate;

        var nextDateEnd = moment(new Date(nextProps.endDate));
        var curDateEnd = this.state.endDate;

        if (curDateStart.diff(nextDateStart, 'days') != 0 || curDateEnd.diff(nextDateEnd, 'days') != 0) {
            this.setState({ startDate: nextDateStart });
            this.setState({ endDate: nextDateEnd });
        }
    }

    clickDatePicker() {
        this
            ._datePicker
            .onInputClick();
    };
    render() {
        var selectedProp = "";
        var selected;
        var includeDates = "";
        var minDate = null;
        var maxDate = null;
        if (this.props.type == "end") {
            selectedProp = "selectsEnd";
            selected = this.state.endDate;
            minDate = this.state.startDate;
            maxDate = moment().add(1, "days");
        } else if (this.props.type == "start") {
            selectedProp = "selectsStart";
            selected = this.state.startDate;
            minDate = null;
            maxDate = this.state.endDate;
        } else { // just one date
            selected = this.state.startDate;
            //  minDate = this.state.startDate;
            // endDate = null;
            minDate = null;
            maxDate = null;
        }
        var classes = "daypickDiv " + this.props.className;
        return (
            <div className={classes}>
                <link rel="stylesheet" type="text/css" href="/css/react-datepicker.min.css" />

                <DatePicker
                    ref={(datePicker) => {
                        this._datePicker = datePicker;
                    }}
                    selected={selected}
                    {...selectedProp}
                    startDate={this.state.startDate}
                    minDate={minDate}
                    maxDate={maxDate}
                    endDate={this.state.endDate}
                    onChange={this
                        .handleChange
                        .bind(this)}
                    className={this.props.className}
                    customInput={< CustomLabel Label={
                        this.props.Label
                    } />} />
                <CustomContainerType
                    value={selected}
                    ContainerType={this.props.ContainerType}
                    onClick={this
                        .clickDatePicker
                        .bind(this)} />
            </div>
        );
    }
};

module.exports = Datepicker;


// WEBPACK FOOTER //
// ./modules/common/datepicker.jsx